import styled from 'styled-components';

export const RichTextStyleWrapper = styled.div`
	overflow-x: auto;

	table {
		display: block;

		td {
			padding: 0.5rem 1rem;
			border: 1px solid #e0e0e0;
		}

		p {
			margin: 0;
		}
	}
`;
